export function ApexLogo({ light = false, className = "" }) {
  const navy = light ? "#FFFFFF" : "#0B192C";
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg width="34" height="34" viewBox="0 0 40 40" fill="none" aria-hidden="true">
        <path d="M20 3 L37 37 L26 37 L20 22 L14 37 L3 37 Z" fill="#C5A059" />
        <path d="M20 3 L28 19 L20 19 Z" fill={navy} />
      </svg>
      <span className="leading-none">
        <span className="font-serif text-xl font-bold" style={{ color: navy }}>
          ApexPath
        </span>
        <span className="ml-1 text-[10px] font-semibold tracking-widest" style={{ color: "#C5A059" }}>
          LTD
        </span>
      </span>
    </div>
  );
}
